// extracted by mini-css-extract-plugin
module.exports = {"container":"_3swufPot","detailContainer":"eJ6kOvhO","padded":"_3m8lSJwa"};
    if(module.hot) {
      // 1754515042643
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  